import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { alpha } from '@mui/material/styles';
import { Box, Typography, Fab } from '@mui/material';
import Iconify from '@/components/Iconify';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';

function TicketCountSelect({
  disabledIncrementer = false,
  disabledDecrementer = false,
  max = 10,
  min = 0,
  value = 0,
  onChange = () => {},
  sx = {},
}) {
  const { t } = useTranslation();
  const [quantity, setQuantity] = useState(value);
  const { increaseNumberOfTickets, decreaseNumberOfTickets } =
    useAnalyticsEvents();
  return (
    <Box
      sx={{
        'backgroundColor': (theme) => theme.palette.primary.palette[50],
        'borderRadius': '24px',
        'border': (theme) =>
          `1px solid ${alpha(theme.palette.primary.palette[600], 0.5)}`,
        'lineHeight': 0,
        'display': 'flex',
        'alignItems': 'center',
        'justifyContent': 'center',
        'padding': '8px 12px',
        'color': (theme) => theme.palette.primary.main,
        '& .Mui-disabled': {
          bgcolor: 'transparent',
        },
        ...sx,
      }}
    >
      <Fab
        size="small"
        color="inherit"
        disabled={disabledDecrementer || quantity <= min}
        onClick={() => {
          const newQuantity = quantity - 1;
          setQuantity(newQuantity);
          onChange(newQuantity);
          decreaseNumberOfTickets(newQuantity);
        }}
        sx={{
          width: '18px',
          height: '18px',
          minHeight: '18px',
          zIndex: 0,
          bgcolor: 'transparent',
        }}
      >
        <Iconify icon={'eva:minus-fill'} width={14} height={14} />
      </Fab>
      <Box sx={{ marginLeft: '8px', marginRight: '8px' }}>
        <Typography
          variant="subtitle2"
          component="span"
          sx={{
            width: 70,
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: 600,
          }}
        >
          {t('checkout.home.cart.quantityTickets', {
            count: quantity,
          })}
        </Typography>
      </Box>

      <Fab
        size="small"
        color="inherit"
        disabled={disabledIncrementer ? true : quantity >= max}
        onClick={() => {
          const newQuantity = quantity + 1;
          setQuantity(newQuantity);
          onChange(newQuantity);
          increaseNumberOfTickets(newQuantity);
        }}
        sx={{
          width: '18px',
          height: '18px',
          minHeight: '18px',
          zIndex: 0,
          bgcolor: 'transparent',
        }}
      >
        <Iconify icon={'eva:plus-fill'} width={14} height={14} />
      </Fab>
    </Box>
  );
}

export default TicketCountSelect;
